import { render, staticRenderFns } from "./PaymentAlert.vue?vue&type=template&id=9dd017f0"
import script from "./PaymentAlert.vue?vue&type=script&lang=js"
export * from "./PaymentAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports